/**
 * @generated SignedSource<<5f49b1026748ca9dc02d7898db1aa584>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CertificatesScreen_WordpressCertificatesQueryFragment$data = {
  readonly Viewer: {
    readonly WordpressCertificateAchievedByUser: {
      readonly wordPressCertificates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly certificateFile: {
              readonly url: string | null;
            } | null;
            readonly contentNodeTitle: string;
            readonly finishedAt: string;
            readonly id: string;
            readonly userName: string;
          };
        } | null> | null;
      };
    };
  };
  readonly " $fragmentType": "CertificatesScreen_WordpressCertificatesQueryFragment";
};
export type CertificatesScreen_WordpressCertificatesQueryFragment$key = {
  readonly " $data"?: CertificatesScreen_WordpressCertificatesQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CertificatesScreen_WordpressCertificatesQueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Viewer",
  "WordpressCertificateAchievedByUser",
  "wordPressCertificates"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sortDirection"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./WordpressCertificates_Refetch.graphql')
    }
  },
  "name": "CertificatesScreen_WordpressCertificatesQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewerQueryType",
      "kind": "LinkedField",
      "name": "Viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WordpressCertificateAchievedByUserViewerSchema",
          "kind": "LinkedField",
          "name": "WordpressCertificateAchievedByUser",
          "plural": false,
          "selections": [
            {
              "alias": "wordPressCertificates",
              "args": [
                {
                  "kind": "Variable",
                  "name": "sortDirection",
                  "variableName": "sortDirection"
                }
              ],
              "concreteType": "WordpressCertificateAndLearnStateConnection",
              "kind": "LinkedField",
              "name": "__CertificatesScreen_wordPressCertificates_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WordpressCertificateAndLearnStateEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WordpressCertificateAndLearnState",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "contentNodeTitle",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "userName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "File",
                          "kind": "LinkedField",
                          "name": "certificateFile",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "url",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "finishedAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "8718f34716085a6c8906fddf35f8ea47";

export default node;
